import { BROWSE_LINK_LIST } from '@/data/constants/BROWSE_LINK_LIST'
import { NextPageContext } from 'next'

export const restrictBrowsePageUsageToWhitelist = ({
  asPath = '',
  res,
}: Pick<NextPageContext, 'asPath' | 'res'>) => {
  const isBrowsePage = asPath.includes('/browse/')
  if (!isBrowsePage) {
    return
  }
  const postBrowseComponent = asPath.split('/browse/').pop() || ''
  const isAllowedBrowse = BROWSE_LINK_LIST.some((list) => (
    list.values.some((value) => (
      value === postBrowseComponent
    ))
  ))
  if (!isAllowedBrowse) {
    res?.setHeader('X-Robots-Tag', 'noindex, nofollow')
    res?.writeHead(301, {
      Location: '/',
      'cache-control': 'public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0',
      'X-Robots-Tag': 'noindex, nofollow',
    }).end()
  }
}
